
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { VaccineSettingApi } from '../api/vaccinesetting.api';
import { switchMap, map } from 'rxjs/operators';

import { VaccineSettingData, VaccineSetting } from '../../../interfaces/masters/vaccinesetting' ;
@Injectable()
export class VaccineSettingService extends VaccineSettingData {

    constructor(private api: VaccineSettingApi) {
      super();
    }
  
  
    list(url: string): Observable<VaccineSetting[]> {
      return this.api.list(url);
    }
  
    getById(url:string): Observable<VaccineSetting>{
        return this.api.getById(url);
    }
  
    create(url: string, data:VaccineSetting): Observable<VaccineSetting[]> {
      return this.api.add(url,data);
    }
  
    update(url: string, data:VaccineSetting): Observable<VaccineSetting> {
      return this.api.update(url,data);
    }
  
    
  
    delete(url: string): Observable<boolean> {
      return this.api.delete(url);
    }
  }
  